export const parseJwt = (token) => {
  try {
    const payload = token.split('.')[1];
    const base64 = payload.replace(/-/g,'+').replace(/_/g, '/');
    const padded = base64.padEnd(base64.length + (4- base64.length % 4) % 4, '=');
    const decoded = JSON.parse(atob(padded));
    return decoded;
  } catch (e) {
    return null;
  }
};